<template>
  <div class="boardingPosition">
    <nav-bar title="上车位置"></nav-bar>
    <van-cell class="cell-pos">
      <template #title>
        <span class="left">当前位置</span>
      </template>
      <template #right-icon>
        <span class="right">北京市</span>
        <van-icon name="arrow-down" />
      </template>
    </van-cell>
    <div class="posList">
      <div class="city">
        <span>北京市</span>
      </div>
      <van-cell>
        <template slot="title">
          <div style="position: relative">
            <span class="custom-title">立水桥—地铁站</span>
            <span class="distance">200米</span>
            <van-icon class="edit" name="edit" color="#212529" />
          </div>
        </template>
      </van-cell>
    </div>
    <div class="bottom">
      <van-button class="boarding" type="default">新增上车地点</van-button>
      <van-button class="car" type="default">新增用车地点</van-button>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import { Icon, Cell, Button } from "vant";

export default {
  name: "boardingPosition",
  components: {
    NavBar,
    "van-icon": Icon,
    "van-cell": Cell,
    "van-button": Button
  }
};
</script>

<style scoped lang="less">
.boardingPosition {
  width: 100%;
  height: 100%;
  background-color: #eee;
}

.select {
  height: 50px;
  margin-top: 10px;
  background-color: #fff;
  padding: 0 20px;
  display: flex;
  align-items: center;

  div {
    width: 100px;
    height: 30px;
    color: #bbb;
    text-align: center;
    border: 1px solid #ccc;

    span {
      font-size: 16px;
    }

    .van-icon {
      font-size: 16px;
      vertical-align: middle;
      margin-left: 8px;
    }
  }
}

.posList {
  .city {
    padding: 0 20px;
    height: 45px;

    span {
      line-height: 45px;
      font-size: 14px;
    }
  }

  .van-cell {
    padding-left: 20px;

    .distance {
      display: inline-block;
      margin-left: 20px;
      font-size: 12px;
      color: #ccc;
    }

    .edit {
      font-size: 18px;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}

.bottom {
  position: absolute;
  bottom: 0;
  padding: 16px 25px;
  .boarding {
    width: 158px;
    height: 44px;
    border-radius: 6px;
    border: 1px solid rgba(33, 37, 41, 1);
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(33, 37, 41, 1);
  }
  .car {
    width: 158px;
    height: 44px;
    background: rgba(33, 37, 41, 1);
    border-radius: 6px;
    font-size: 15px;
    border: 1px solid rgba(33, 37, 41, 1);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    margin-left: 8px;
  }
}

.cell-pos {
  align-items: center;

  .left {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(33, 37, 41, 1);
  }

  .right {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(98, 104, 112, 1);
    margin-right: 7px;
  }
}
</style>
